import { Component, Injector, OnInit } from '@angular/core';
import {FormGroup} from '@angular/forms';

import {
  Offer, ResponsePrecontractInfo,
  StepData
} from 'models';
import {of} from 'rxjs';
import {catchError, debounceTime, filter, first} from 'rxjs/operators';
import {SimTypeEnum} from '../../../../../../app-shared/models/steps/step-sim.interface';

import { ProcessStepBaseComponent } from '../../_core/process-step-base.component';

@Component({
  selector: 'sb-step-winback',
  templateUrl: './consents.component.html',
  styleUrls: ['./consents.component.scss']
})
export class ConsentsComponent extends ProcessStepBaseComponent implements OnInit {
  public SIM_TYPES = SimTypeEnum;
  public simType: SimTypeEnum;
  public precontractUrl = '';

  public consentFormIsOpen: boolean;
  public consentFormHasBeenOpened: boolean;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    // super.shouldShowBackButton();
    super.isStickyNavigation();
    super.setFormGroup(this.formsService.generateStepConsentsForm());
    super.setFormStoreDataFunction(this.appStoreFacadeService.step.storeStepConsentsValue);
    this.getFormDataAndValidation();
  }

  goToNextStep() {
    if (!this.consentFormIsOpen) {
      // CASE 1: If form is closed, let's enable all consents
      this.formGroup.patchValue({
        marketingConsents: {
          ownAndThirdServicesMarketingAccepted: true,
          geolocalizationDataAndProfilingAccepted: true,
          thirdServicesEnrichmentAccepted: true,
          thirdServicesTransferAccepted: true
        }
      });
    }

    return super.goToNextStep();
  }

  private getFormDataAndValidation() {
    this.subscriptions.add(
      this.appStoreFacadeService.step.consents$
        .subscribe((stepData: StepData) => {
          super.setFormGroupStepData(stepData);
        })
    );

    this.subscriptions.add(
      this.appStoreFacadeService.step.consentsValue$
        .pipe(debounceTime(150), first(Boolean))
        .subscribe(() => {
          this.sendAnalyticsData();
        })
    );
  }

  public checkCustomInvalidFields() {
    // Opens consents if invalid
    const consentFormGroup = this.formGroup.get('marketingConsents');
    if (consentFormGroup.invalid) {
      // this.toggleConsents(true);
    }
  }

  public onToggleConsents() {
    this.consentFormHasBeenOpened = true;
    this.consentFormIsOpen = true;
    /*const currentConsents = this.formGroup.get('marketingConsents').value || {};
    let isAtLeastOneTrue = false;
    let allIsNull = true;
    Object.keys(currentConsents).forEach(r => {
      if (currentConsents[r]) { isAtLeastOneTrue = true; }
      if (currentConsents[r] !== null) { allIsNull = false; }
    });
    if (!isAtLeastOneTrue && !allIsNull) {
      this.formGroup.patchValue({
        marketingConsents: {
          ownAndThirdServicesMarketingAccepted: true,
          geolocalizationDataAndProfilingAccepted: true,
          thirdServicesEnrichmentAccepted: true,
          thirdServicesTransferAccepted: true
        }
      });
    }*/
  }

  public onCloseConsents() {
    this.consentFormHasBeenOpened = true;
    this.consentFormIsOpen = false;
  }
}
